import { AddAPhoto } from '@mui/icons-material';
import { Box, Button, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

interface EmptyStateProps {
  isMobile: boolean;
  onUploadClick: () => void;
}

export function EmptyState({ isMobile, onUploadClick }: EmptyStateProps) {
  const { t } = useTranslation();

  return (
    <Box
      sx={{
        border: 2,
        borderStyle: 'dashed',
        borderColor: 'divider',
        borderRadius: 2,
        p: 4,
        textAlign: 'center',
        bgcolor: 'action.hover',
      }}
    >
      <Typography
        variant="body2"
        sx={{
          color: 'text.secondary',
        }}
      >
        {t('goodsReceiving.noPhotos')}
      </Typography>
      <Button
        variant="outlined"
        startIcon={<AddAPhoto />}
        onClick={onUploadClick}
        sx={{ mt: 2 }}
        fullWidth={isMobile}
      >
        {t('goodsReceiving.uploadPhoto')}
      </Button>
    </Box>
  );
}
